"use strict";
var set = (typeof Set === 'function') ? new Set() : (function () {
    var list = [];
    return {
        has: function (key) {
            return Boolean(list.indexOf(key) > -1);
        },
        add: function (key) {
            list.push(key);
        },
        delete: function (key) {
            list.splice(list.indexOf(key), 1);
        },
    };
})();
var createEvent = function (name) { return new Event(name); };
try {
    new Event('test');
}
catch (e) {
    createEvent = function (name) {
        var evt = document.createEvent('Event');
        evt.initEvent(name, true, false);
        return evt;
    };
}
function assign(ta, options) {
    if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || set.has(ta))
        return;
    var heightOffset = null;
    var clientWidth = ta.clientWidth;
    var cachedHeight = null;
    function init() {
        var style = window.getComputedStyle(ta, null);
        if (style.resize === 'vertical') {
            ta.style.resize = 'none';
        }
        else if (style.resize === 'both') {
            ta.style.resize = 'horizontal';
        }
        if (style.boxSizing === 'content-box') {
            heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
        }
        else {
            heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
        }
        if (isNaN(heightOffset)) {
            heightOffset = 0;
        }
        update();
    }
    function changeOverflow(value) {
        {
            var width = ta.style.width;
            ta.style.width = '0px';
            ta.offsetWidth;
            ta.style.width = width;
        }
        ta.style.overflowY = value;
        resize();
    }
    function getParentOverflows(el) {
        var arr = [];
        while (el && el.parentNode && el.parentNode instanceof Element) {
            if (el.parentNode.scrollTop) {
                arr.push({
                    node: el.parentNode,
                    scrollTop: el.parentNode.scrollTop,
                });
            }
            el = el.parentNode;
        }
        return arr;
    }
    function resize() {
        var originalHeight = ta.style.height;
        var overflows = getParentOverflows(ta);
        var docTop = document.documentElement && document.documentElement.scrollTop;
        ta.style.height = 'auto';
        var endHeight = ta.scrollHeight + heightOffset;
        if (ta.scrollHeight === 0) {
            ta.style.height = originalHeight;
            return;
        }
        ta.style.height = endHeight + 'px';
        clientWidth = ta.clientWidth;
        overflows.forEach(function (el) {
            el.node.scrollTop = el.scrollTop;
        });
        if (docTop) {
            document.documentElement.scrollTop = docTop;
        }
    }
    function update() {
        resize();
        var computed = window.getComputedStyle(ta, null);
        var computedHeight = Math.round(parseFloat(computed.height));
        var styleHeight = Math.round(parseFloat(ta.style.height));
        if (computedHeight !== styleHeight) {
            if (computed.overflowY !== 'visible') {
                changeOverflow('visible');
            }
        }
        else {
            if (computed.overflowY !== 'hidden') {
                changeOverflow('hidden');
            }
        }
        if (cachedHeight !== computedHeight) {
            cachedHeight = computedHeight;
            var evt = createEvent('autosize:resized');
            ta.dispatchEvent(evt);
        }
    }
    var pageResize = function () {
        if (ta.clientWidth !== clientWidth) {
            update();
        }
    };
    var destroy = function (style) {
        window.removeEventListener('resize', pageResize, false);
        ta.removeEventListener('input', update, false);
        ta.removeEventListener('keyup', update, false);
        ta.removeEventListener('autosize:destroy', destroy, false);
        ta.removeEventListener('autosize:update', update, false);
        set.delete(ta);
        Object.keys(style).forEach(function (key) {
            ta.style[key] = style[key];
        });
    };
    destroy.bind(ta, {
        height: ta.style.height,
        resize: ta.style.resize,
        overflowY: ta.style.overflowY,
        overflowX: ta.style.overflowX,
        wordWrap: ta.style.wordWrap,
    });
    ta.addEventListener('autosize:destroy', destroy, false);
    if ('onpropertychange' in ta && 'oninput' in ta) {
        ta.addEventListener('keyup', update, false);
    }
    window.addEventListener('resize', pageResize, false);
    ta.addEventListener('input', update, false);
    ta.addEventListener('autosize:update', update, false);
    set.add(ta);
    ta.style.overflowX = 'hidden';
    ta.style.wordWrap = 'break-word';
    init();
}
function destroy(ta) {
    if (!(ta && ta.nodeName && ta.nodeName === 'TEXTAREA'))
        return;
    var evt = createEvent('autosize:destroy');
    ta.dispatchEvent(evt);
}
function update(ta) {
    if (!(ta && ta.nodeName && ta.nodeName === 'TEXTAREA'))
        return;
    var evt = createEvent('autosize:update');
    ta.dispatchEvent(evt);
}
var autosize = null;
if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
    autosize = function (el) { return el; };
    autosize.destroy = function (el) { return el; };
    autosize.update = function (el) { return el; };
}
else {
    autosize = function (el, options) {
        if (el) {
            Array.prototype.forEach.call(el.length ? el : [el], function (x) { return assign(x, options); });
        }
        return el;
    };
    autosize.destroy = function (el) {
        if (el) {
            Array.prototype.forEach.call(el.length ? el : [el], destroy);
        }
        return el;
    };
    autosize.update = function (el) {
        if (el) {
            Array.prototype.forEach.call(el.length ? el : [el], update);
        }
        return el;
    };
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = autosize;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/forms/text-area/autosize.js
// module id = 66
// module chunks = 0